import { render, staticRenderFns } from "./RealEstateDropZone.vue?vue&type=template&id=40108984&"
import script from "./RealEstateDropZone.vue?vue&type=script&lang=js&"
export * from "./RealEstateDropZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports